// @vendors
const Immutable = require('immutable');
const { get } = require('lodash');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const initialState = Immutable.fromJS({
    assetAllocation: [],
    product: {
        typeOfProduct: '',
    },
    portfolioName: '',
    totals: {
        valuation: 0,
        netReturn: 0,
        simpleReturn: 0,
        deposits: 0,
        withdrawals: 0,
        investedAmount: 0,
        initialInvestment: 0,
    },
    periodicTransfer: {
        amount: 0,
        code: 0,
        nextDate: '',
    },
    isFetching: false,
    isSuccess: false,
    isUpdating: false,
    updateError: false,
    portfolioStartDate: '',
    portfolioId: '',
    error: null,
    errorTitle: false,
});

const sortByAssetClassId = assetAllocation => {
    const sortedAssetAllocation = assetAllocation.sort((a, b) => {
        if (a.assetClassId < b.assetClassId) return -1;
        if (a.assetClassId > b.assetClassId) return 1;
        return 0;
    });

    return sortedAssetAllocation;
};

const parseResponse = (state, response) => {
    const {
        assetAllocation,
        keyFigures,
        recurringTransfers,
        product,
        name,
        created,
        id,
        state: portfolioState,
    } = response;

    return state.merge({
        portfolioName: name,
        assetAllocation: sortByAssetClassId(assetAllocation),
        product: {
            typeOfProduct: product.typeOfProduct,
        },
        totals: {
            valuation: keyFigures.valuation,
            netReturn: keyFigures.netReturn,
            simpleReturn: keyFigures.simpleReturn,
            timeWeightedReturn: keyFigures.timeWeightedReturn,
            deposits: keyFigures.deposits,
            withdrawals: keyFigures.withdrawals,
            investedAmount: keyFigures.investedAmount,
            initialInvestment: keyFigures.initialInvestment,
        },
        periodicTransfer: {
            amount: get(recurringTransfers, 'amount', 0),
            code: get(recurringTransfers, 'recurringCode', ''),
            nextDate: get(recurringTransfers, 'nextTransferDate', ''),
            accountContract: get(
                recurringTransfers,
                'originalAccount.contrato',
                '',
            ),
        },
        isFetching: false,
        isSuccess: true,
        portfolioStartDate: created,
        portfolioId: id,
        state: portfolioState,
    });
};

const extractPortfolioDetail = (state, response) => {
    const portfolioId = state.get('portfolioId');
    return get(response, 'roboAdvisor.portfolioOverviews', []).find(
        portfolio => portfolio.id === portfolioId,
    );
};

const RAPortfolioDetails = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_PORTFOLIO_DETAILS_RESET:
            return initialState;
        case actionTypes.BROKER_GET_MY_INVESTMENTS_REQUEST:
            return state.merge({ isFetching: true, error: null });
        case actionTypes.BROKER_GET_MY_INVESTMENTS_FAILURE:
            return state.merge({ isFetching: false, error: true });
        case actionTypes.BROKER_GET_MY_INVESTMENTS_SUCCESS:
            if (!!state.get('portfolioId')) {
                return parseResponse(
                    state,
                    extractPortfolioDetail(state, action.payload),
                );
            } else {
                return state;
            }
        case actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_DATA:
            return parseResponse(state, action.payload.data);
        case actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_FAILURE:
            return state.merge({
                isUpdating: false,
                updateError: action.payload,
            });
        case actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_IN_PROGRESS:
            return state.merge({ isUpdating: true });
        case actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_SUCCESS:
            return state.merge({
                isUpdating: false,
                portfolioName: action.payload.portfolioName,
                errorTitle: false,
            });
        case actionTypes.RA_PORTFOLIO_DETAILS_HEADER_TITLE_ERROR_ENABLED:
            return state.merge({
                errorTitle: true,
            });
        default:
            return state;
    }
};

module.exports = RAPortfolioDetails;
